import React from "react";
import { Routes, Route } from "react-router-dom";
import InitiativesList from "./InitiativesList";
import InitiativeDetail from "./InitiativeDetail";

const Initiatives = () => {
  return (
    <Routes>
      <Route path="/" element={<InitiativesList />} />
      <Route path="/:id" element={<InitiativeDetail />} />
    </Routes>
  );
};

export default Initiatives;
